import API_ENDPOINTS from "../config/apiEndpoints";
import { axiosInstanceSecured } from "./axiosInstance";

// export const GetConfigurationList = async (ConfigType, Brand, Club) => {
//   try {
//     const response = await axiosInstance.get(
//       `${API_ENDPOINTS.CONFIG.GET_CONFIG}?configType=${ConfigType}&brandName=${Brand}&clubType=${Club}`
//     );
//     return response.data;
//   } catch (error) {
//     console.log(error);
//     if (error.response && error.response?.data) {
//       return { isSuccess: false, message: error.response.data };
//     } else {
//       return {
//         isSuccess: false,
//         message: "An Internal Error occured. Try again after some time",
//       };
//     }
//   }
// };

// export const UpsertConfiguration = async (fromData) => {
//   try {
//     const response = await axiosInstance.post(
//       `${API_ENDPOINTS.CONFIG.UPSERT_CONFIG}`,
//       fromData
//     );
//     return response.data;
//   } catch (error) {
//     console.log(error);
//     if (error.response && error.response?.data) {
//       return { isSuccess: false, message: error.response.data };
//     } else {
//       return {
//         isSuccess: false,
//         message: "An Internal Error occured. Try again after some time",
//       };
//     }
//   }
// };

export const ValidateEmail_Experian=async(data)=>{
  try {
    const response = await axiosInstanceSecured.post(`${API_ENDPOINTS.VALIDATE_ADDRESS.VALIDATE_EMAIL}`, data
    );
    return response.data;
  } catch (error) {
    console.error('Error fetching data:', error);
    throw error; 
  }
}

export const Verify_Captcha=async(data)=>{
  try {
    const response = await axiosInstanceSecured.post(`${API_ENDPOINTS.CAPTCHA.VERIFY_CAPTCHA}`, data
    );
    return response.data;
  } catch (error) {
    console.error('Error fetching data:', error);
    throw error; 
  }
}

export const getExperianPhoneValid=async(payload)=>{
  try {
    const response = await axiosInstanceSecured.post(`${API_ENDPOINTS.VALIDATE_ADDRESS.VALIDATEPHONE}`, payload
    );
    return response.data;
  } catch (error) {
    console.error('Error fetching data:', error);
    throw error; 
  }
}

export const CheckCustomerDataCommerceTool=async(data)=>{
  try {
    const response = await axiosInstanceSecured.post(
      `${API_ENDPOINTS.Customer.CHECK_COMMERCE_CUSTOMER}`,
      data
    );
    // console.log("response for customerdata", response?.data);
    return response.data;
    
  } catch (error) {
    console.error('Error fetching data:', error);
    throw error; 
  }
}

export const AddCustomerDataCommerceTool=async(data,checkToken)=>{
  try {
    const response = await axiosInstanceSecured.post(
      `${API_ENDPOINTS.Customer.Commerce_Add_Customer}`,
      data,
      {
        headers: {
          CheckToken: checkToken,   // <-- new
        },
      }
    );
    // console.log("response for customerdata", response?.data);
    return response.data;
    
  } catch (error) {
    console.error('Error fetching data:', error);
    throw error; 
  }
}

export const getExperianConfig=async()=>{
  try {
    const response = await axiosInstanceSecured.post(`${API_ENDPOINTS.VALIDATE_ADDRESS.GETEXPERIAN_CONFIG}`
    );
    return response.data;
  } catch (error) {
    console.error('Error fetching data:', error);
    throw error; 
  }
}

export const searchAddressByKeyWord=async(data)=>{
  try {
    const response = await axiosInstanceSecured.post(`${API_ENDPOINTS.VALIDATE_ADDRESS.EXPERIAN_SEARCH_BY_KEYWORDS}`, data
    );
    return response.data;
  } catch (error) {
    console.error('Error fetching data:', error);
    throw error; 
  }
}

export const getIndvidual_Experian=async(data)=>{
  try {
    const response = await axiosInstanceSecured.post(`${API_ENDPOINTS.VALIDATE_ADDRESS.GET_FORMAT_ADDRESS}`,null,
    {
      params: data,
    }
    );
    return response.data;
  } catch (error) {
    console.error('Error fetching data:', error);
    throw error; 
  }
}